export default __webpack_public_path__ + "media/images/supplied/metalStructure-5f4bdedc084f31fbb68b2b2a0b0fb5cb.jpg";